import React from 'react';
import { View, Text, StyleSheet, Image, TouchableWithoutFeedback } from 'react-native';
// import moment from 'moment';
const width = 480;
const _width = window.innerWidth;

const videoIcon = require('./../assets/assets_png/video.png');
const pdfIcon = require('./../assets/assets_png/material.png');
const testIcon = require('./../assets/assets_png/test.png');
const epubIcon = require('./../assets/assets_png/epub.png');
const calendarIcon = require('./../assets/assets_png/calendar.png');
const rightArrow = require('./../assets/assets_png/rightArrow.png');
const lock = require('./../assets/assets_png/lock.png');
const pptIcon = require('./../assets/pptIcon.png');
const contentBG = require('./contentBG.png');

// const isValidDate = date => moment(date).isValid();
// const showMessage = (scheduled_date_time, callBack) => {
//     let msg = 'Not Scheduled';
//     if(isValidDate(scheduled_date_time)) {
//         if(moment() < moment(scheduled_date_time)) {
//             msg = `Live should starts in ${moment(scheduled_date_time).fromNow()}`;
//         }else {
//             msg = `Live has started ${moment(scheduled_date_time).fromNow()}`
//         }
//     }
//     callBack(msg, 2000)
// }

const CourseTitleBG = ({color='red', width=200, height=256}) => {
    return (
        // <svg width="800" height="600" xmlns="http://www.w3.org/2000/svg">
        //     <g>
        //         <title>background</title>
        //         <rect fill="#fff" id="canvas_background" height="602" width="802" y="-1" x="-1" />
        //         <g display="none" overflow="visible" y="0" x="0" height="100%" width="100%" id="canvasGrid">
        //             <rect fill="url(#gridpattern)" stroke-width="0" y="0" x="0" height="100%" width="100%" />
        //         </g>
        //     </g>
        //     <g>
        //         <title>Layer 1</title>
        //         <g stroke="null" id="svg_5">
        //             <path stroke="null" id="svg_4" d="m468.49041,356.66606c-29.48249,71.79122 -150.36071,70.43024 -181.15354,-2.04146c-30.79283,-72.4717 28.17216,-216.05413 88.77506,-215.37365c60.27532,0.68049 121.86097,145.62389 92.37848,217.4151z" fill={color || "#FF0066"} />
        //         </g>
        //     </g>
        // </svg>
        <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">       
        <g>
         <title>background</title>
         <rect fill="none" id="canvas_background" height="258" width="202" y="-1" x="-1"/>
        </g>
        <g>
         <title>Layer 1</title>
         <g stroke="null" id="svg_5">
          <path stroke="null" id="svg_1" d="m190.56755,202.98348c-29.18347,65.9524 -148.83573,64.70212 -179.31624,-1.87542c-30.48051,-66.57754 27.88643,-198.48235 87.87469,-197.85721c59.664,0.62514 120.62502,133.78023 91.44155,199.73263z" fill={color}/>
         </g>
        </g>
       </svg>
   
    )
}

  

const contentComponent = ({material, key, navigation, isUserPaid, isFree, onPress}) => {
    const {title, file_type, content_url,
        html_content, is_paid,course_id, exam_id, lesson_planner_id, id, 
        video_type, scheduled_date_time} = material;
    return(
        <TouchableWithoutFeedback
         key={key}
         onPress = {()=> { 

                //     return this.props.navigation.navigate('TermsAndConditions', {
                //         testId: id,
                //         isMaterialTest: true
                //     })
                // }
                // if(file_type === "scheduled") return showMessage(scheduled_date_time);    // if(file_type === 'test') {
            
                if((!content_url && (file_type === 'test' || file_type === 'epub')) || content_url) {
                    return onPress();
                   navigation.navigate('ShowContentScreen', {
                        contentUrl: content_url,
                        contentType: file_type,
                        html_content: html_content,
                        title: title,
                        contentId: id,
                        subjectId: course_id,
                         examId: exam_id,
                         topicId: lesson_planner_id,
                         formLibrary: false,
                         videoType: video_type || null,
                        //  mentor_name,
                        //  facultyInfo
                    })
                    return;                                             
                
                // if(!content_url) return this.showToaster("Not available");
            }
            
            // return this.showToaster("Please purchase to Continue.", 2000);                                  

        }}
        >
       
            <View style={styles.courseWrapper} key={key}>
                <View style={{marginTop: 10, marginBottom: 10}}>
                    <Image
                        source={
                        
                            file_type === 'live' ? videoIcon
                            :
                            file_type === "scheduled" 
                            ?
                            calendarIcon
                            :
                            file_type === 'video'
                            ?
                            videoIcon 
                            : 
                            file_type === 'media_id'
                            ?
                            videoIcon 
                            :
                            file_type === 'test' 
                            ?
                            testIcon 
                            : 
                            file_type === 'pdf' 
                            ?
                            pdfIcon
                            :
                            file_type === 'epub'
                            ?
                            epubIcon
                            :
                            // file_type === 'ppt'
                            // ?
                            // pptIcon
                            // :
                            null
                        }
                        style={{
                            width: 64,
                            height: 64
                        }}
                    />
                </View>
                <View style={{alignSelf: 'flex-start', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>

                
                    <div style={{ position: 'absolute', zIndex: -1,opacity: 0.7, left: 10}}>
                        {/* <CourseTitleBG height={32} width={32}/> */}
                        {/* <img src={contentBG} width={63} height={90} style={{transform: 'rotate(90deg)'}} /> */}
                    </div>
                    <View style={{marginHorizontal: 10, flexWrap: 'wrap', flexDirection: 'column', alignItems:'center'}}>

                    {
                        file_type === "scheduled" 
                        ?
                        <Text 
                        ellipsizemode={'tail'}
                        numberOfLines={2}
                        style={styles.title}
                            
                    >
                         Live starts 
                         {/* { isValidDate(scheduled_date_time) ? moment(scheduled_date_time).format('MMMM Do YYYY, h:mm a') : '-'} */}
                         </Text> 
                    :
                        <Text  
                        ellipsizemode={'tail'}
                        numberOfLines={2}
                        style={styles.title}
                            
                        >{title}</Text>    
                                                                                    
                    } 
                </View>
              
                </View>
                <View style={{marginLeft: 'auto', alignSelf: 'flex-end', }}> 
                    <Image source={(isUserPaid || isFree || !is_paid) ? rightArrow : lock }
                     style={{width: 24, height: 24}}
                    />
                </View> 
        </View>
    </TouchableWithoutFeedback>
    )
}

export default contentComponent;
const styles = StyleSheet.create({
    courseWrapper: {
        paddingHorizontal: 8,
        paddingVertical: 12,
        justifyContent: 'flex-start',
        // alignItems: '',
        flexDirection: 'column',
        borderRadius: 10,
        marginBottom: 12,
        // borderColor: '#ccc' ,
        marginTop: 5,   
       borderWidth: 3,
       borderColor: '#fff',
       alignItems:'center',
       height: 150,
       marginHorizontal: 15,
       width:_width <= 479  ? Math.floor(_width - 30) : Math.floor(width/2 - 30),
    },
    title: {
        fontSize: 16,
        color: 'rgba(0,0,0,0.7)',
        fontWeight: '700',
        paddingRight: 5
        
    },
    duration: {
        fontSize: 14,
        color: 'rgba(0,0,0,0.7)',
        fontWeight: '600',
        
        
    },
})